import { useState } from 'react';
import { MdArrowRightAlt } from "react-icons/md";
import classes from './callToAction.module.scss';
import Modal from '../../elements/Modal/modal';
import Appointment from '../appointment/appointment';


export default function CallToAction() {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div className={classes.module}>
      <div className={classes.content}>
        <span className={classes.title}>Crafting Tomorrow's Smiles Today</span>
        <div className={classes.desc}>
          <span>
            TX-Genius Empowers You to Deliver AI Personalized, Patient-Approved <br />
            Treatments in Days, Not Weeks!
          </span>
          <button onClick={handleOpenModal}>
            Book a Demo <MdArrowRightAlt size={25} />
          </button>
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal} background='var(--blue-50)'>
        <Appointment />
      </Modal>
    </div>
  );
}  